import React, {useMemo} from "react";
import useIndexData from "../components/indexData";
import {ArticleLongData, ArticlesList, Jumbo, KnowledgeBasePost, StrapiLayout} from "@klear/open-site";

const {Helmet} = require("react-helmet");

const styles = require("../styles/index.module.scss");

const topImage = "https://klear.com/images/new/tosHeader.gif";

declare global {
    interface Document {
        documentMode: number;
    }
}

export default () => {
    const allData = useIndexData();
    const allStrapiProductUpdate = allData.allStrapiProductUpdate.edges;
    const footerData = allData.strapiFooter;

    const ArticlesListData: Array<ArticleLongData> = useMemo(() => {
        const data: Array<ArticleLongData> = [];
        allStrapiProductUpdate.forEach((productUpdate: {node: KnowledgeBasePost}) => {
            data.push({slug: productUpdate.node.slug,imageUrl: productUpdate.node.img.url, title: productUpdate.node.title, description: productUpdate.node.description})
        });
        return data;
    }, [allStrapiProductUpdate]);

    return (
        <>
            <Helmet>
                <title>Product Updates | Klear</title>
                <meta name="description"
                      content="Discover the latest influencer marketing features, designed to enhance and support world-class influencer strategy."/>
                <meta name="image" content={topImage} />
                <meta property="og:image" content={topImage} />
            </Helmet>
            <StrapiLayout footerProps={footerData} requireLogin>
                <>
                    <div className={styles.container}>
                        <Jumbo title="Klear Product Updates"
                               subTitle="Discover the latest influencer marketing features, designed to enhance and support world-class influencer strategy."
                               topImage={topImage}
                               bottomBorder
                        />
                        <ArticlesList
                            posts={ArticlesListData}
                        />
                    </div>
                </>
            </StrapiLayout>
        </>
    )
};